module.exports = __webpack_public_path__ + "static/media/image9.5a9633a8.jpeg";